import PostNavigator from './PostNavigator';

export default PostNavigator;
export * as PostNavigatorStyles from './PostNavigator.styles';
export * as PostNavigatorTypes from './PostNavigator.types';
